import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography, Alert, CircularProgress, Paper } from '@mui/material';
import apiClient from '../services/api';

function validateEmail(email) {
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
}

function validatePassword(password) {
  return password.length >= 8 && /[a-z]/.test(password) && /[A-Z]/.test(password) && /\d/.test(password);
}

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [usernameError, setUsernameError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    // 校验邮箱
    if (!validateEmail(username)) {
      setUsernameError('请输入合法的邮箱地址');
      return;
    } else {
      setUsernameError('');
    }
    // 校验密码
    if (!validatePassword(password)) {
      setPasswordError('密码需8位及以上，包含大小写字母和数字');
      return;
    } else {
      setPasswordError('');
    }
    setLoading(true);
    try {
      const res = await apiClient.post('/api/auth/login', { username, password });
      if (!res.success || !res.data?.token) throw new Error(res.message || '登录失败');
      localStorage.setItem('auth_token', res.data.token);
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        navigate('/dashboard');
      }, 1000);
    } catch (err) {
      setError(err.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f7fa' }}>
      <Paper elevation={3} sx={{ p: 4, maxWidth: 360, width: '100%', borderRadius: 3 }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 700, textAlign: 'center' }}>登录</Typography>
        <form onSubmit={handleLogin} autoComplete="off">
          <TextField
            label="邮箱"
            fullWidth
            margin="normal"
            value={username || ""}
            onChange={e => setUsername(e.target.value)}
            disabled={loading || success}
            error={!!usernameError}
            helperText={usernameError}
            autoComplete="username"
          />
          <TextField
            label="密码"
            type="password"
            fullWidth
            margin="normal"
            value={password || ""}
            onChange={e => setPassword(e.target.value)}
            disabled={loading || success}
            error={!!passwordError}
            helperText={passwordError || '密码需8位及以上，包含大小写字母和数字'}
            autoComplete="current-password"
          />
          {success && <Alert severity="success" sx={{ mt: 2 }}>登录成功，正在进入系统...</Alert>}
          {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 3, py: 1.2, fontSize: 16, fontWeight: 600 }}
            disabled={loading || !username || !password || success}
          >
            {loading ? <CircularProgress size={24} /> : '登录'}
          </Button>
        </form>
        <Button
          variant="text"
          color="primary"
          fullWidth
          sx={{ mt: 2, fontWeight: 500 }}
          onClick={() => navigate('/')}
        >
          返回前台首页
        </Button>
      </Paper>
    </Box>
  );
} 